import React from 'react';
import IconPicker from '../../../shared/IconPicker';
import { IconPickerIcon, ChevronDownIcon } from '../icons';

/**
 * IconPickerDropdown Component
 * Dropdown for changing icon of selected missions
 */
const IconPickerDropdown = ({
  isActive,
  onToggle,
  onIconChange,
  onClose,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={onToggle}
        title="Change icon"
      >
        <IconPickerIcon />
        <span>Icon</span>
        <ChevronDownIcon />
      </button>
      {isActive && (
        <IconPicker
          currentIcon={null}
          onIconChange={onIconChange}
          onClose={onClose}
          position={{ 
            x: buttonRef.current?.getBoundingClientRect()?.left || 100, 
            y: (buttonRef.current?.getBoundingClientRect()?.top || 100) - 450 
          }}
        />
      )}
    </div>
  );
};

export default IconPickerDropdown;
